import { initialStateByModule } from './state'
import productConfigs from '@/products'

const SET_PRODUCT = 'setProduct'
const SET_LEAD_UUID = 'setLeadUuid'

const state = initialStateByModule('product')

const mutations = {
  [SET_PRODUCT] (state, payload) {
    Object.assign(payload, productConfigs())
    state = payload
  },
  [SET_LEAD_UUID] (state, payload) {
    state.lead.uuid = payload
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
